import { Link } from "react-router-dom";

const UPLOADS_URL = "https://bodiosyakdown.com/uploads";

export function ProductCard({
  id,
  image,
  name,
  price,
  altText,
  stock,
  colors = [],
  category,
}) {
  const imageUrl = image ? encodeURI(`${UPLOADS_URL}/${image}`) : null;
  const outOfStock = stock === 0;

  return (
    <div
      className={`p-5 flex flex-col justify-between items-center mx-auto w-full mb-[26px] transition-all duration-300 ${
        outOfStock ? "opacity-70 brightness-90" : ""
      }`}
    >
      <Link to={`/product/${id}`} className="hover:opacity-90 transition w-full">
        <div className="w-full rounded-lg overflow-hidden">
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={altText || name}
              loading="lazy"
              decoding="async"
              className="object-cover w-full h-auto max-w-[540px] max-h-[810px] transition-transform duration-300"
            />
          ) : (
            <div className="w-full h-64 bg-gray-200 flex items-center justify-center rounded-lg">
              <span className="text-gray-400">No image</span>
            </div>
          )}
        </div>

        {colors.length > 0 && (
          <div className="mt-4 flex items-center gap-2 flex-wrap">
            {colors.map((color) => (
              <span
                key={`${id}-${color.name}`}
                title={color.name}
                className={`inline-block w-4 h-4 rounded-full ${color.className || "bg-gray-300"}`}
              />
            ))}
          </div>
        )}

        <div className="mt-4 flex items-start justify-between gap-3">
          <h3 className="text-lg font-libreFranklin text-left text-gray-800">
            {name}
          </h3>
          {category ? (
            <span className="text-xs uppercase tracking-wide text-gray-500 whitespace-nowrap mt-1">
              {category}
            </span>
          ) : null}
        </div>

        <p className="text-md font-libreFranklin font-light text-left mt-2 text-gray-600">
          {Number(price).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          })}
        </p>

        {outOfStock && (
          <p className="text-sm text-red-600 mt-2 font-medium float-right">
            Out of stock
          </p>
        )}
      </Link>
    </div>
  );
}